// src/components/ChecklistPanelModal.jsx
import React from "react";
import ChecklistPanel from "./ChecklistPanel";
import "./ChecklistPanelModal.css";

const ChecklistPanelModal = ({ user, onClose }) => {
  return (
    <div className="cpm-overlay" onClick={onClose}>
      <div className="cpm-box" onClick={(e) => e.stopPropagation()}>
        <div className="cpm-header">
          <span className="cpm-title">Checklists</span>
          <button type="button" className="cpm-close" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="cpm-body">
          <ChecklistPanel user={user} />
        </div>
      </div>
    </div>
  );
};

export default ChecklistPanelModal;
